import {
    IUpdateTagAction,
    organizationActions,
    organizationSelectors,
} from '../../../../../../../actions';
import {
    useAppDispatch,
    useAppSelector,
} from '../../../../../../../base/base-redux';
import { ITag } from '../../../../../../../common';
import TagEditMenu from '../../../../../../base-components/PargodaTagsEditor/TagsEditMenu';

interface ITagsFilterMenuProps {
    appliedTags: Array<ITag>;
    onTagApply: (tag: ITag) => void;
    onTagUnapply: (tagId: number) => void;
}

const TagsFilterMenu = (props: ITagsFilterMenuProps) => {
    const { appliedTags, onTagApply, onTagUnapply } = props;
    const dispatch = useAppDispatch();
    const existingTags = useAppSelector(organizationSelectors.getTags);

    const handleTagCreate = (tagName: string) => {
        dispatch(
            organizationActions.createTag({
                label: tagName,
                color: '#000000',
            })
        );
    };

    const handleTagRemove = (tagId: string) => {
        dispatch(organizationActions.deleteTag({ id: tagId }));
    };

    const handleTagUpdate = (tag: ITag) => {
        const payload: IUpdateTagAction = {
            tag_id: tag.tag_id,
            label: tag.label,
            color: tag.color,
        };
        dispatch(organizationActions.updateTag(payload));
    };

    return (
        <TagEditMenu
            isFilter={true}
            appliedTags={appliedTags}
            existingTags={existingTags}
            onTagCreate={handleTagCreate}
            onTagRemove={handleTagRemove}
            onTagUpdate={handleTagUpdate}
            onTagApply={onTagApply}
            onTagUnapply={onTagUnapply}
        />
    );
};

export default TagsFilterMenu;
